import { GET_CONNECTIONS, GET_CONNECTIONS_SUCCESS } from '../constants/action-types/connections';
import { initialState } from '../store/models/connections';

export default function connectionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONNECTIONS:
      return {
        ...state,
        data: [],
        isLoading: true,
      };
    case GET_CONNECTIONS_SUCCESS:
      return {
        ...state,
        data: action.data,
        isLoading: false,
      };
    default:
      return state;
  }
}
